import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_form_field = _resolveComponent("bs5-form-field")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    as: "",
    "validation-schema": _ctx.schema
  }, {
    default: _withCtx(({ meta, handleSubmit }) => [
      _createVNode(_component_bs5_base_modal, {
        title: _ctx.$t('users.editTitle'),
        visible: _ctx.visible,
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            novalidate: "",
            onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.updateUser)), ["prevent"])
          }, [
            _createVNode(_component_bs5_form_field, {
              id: "editUserFullName",
              name: "fullName",
              icon: "bi-person",
              autocomplete: "name",
              label: _ctx.$t('users.fullName'),
              modelValue: _ctx.user.fullName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.fullName) = $event))
            }, null, 8, ["label", "modelValue"]),
            _createVNode(_component_bs5_form_field, {
              id: "editUserEmail",
              name: "email",
              type: "email",
              icon: "bi-envelope",
              autocomplete: "off",
              label: _ctx.$t('users.email'),
              modelValue: _ctx.user.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.email) = $event))
            }, null, 8, ["label", "modelValue"]),
            _createVNode(_component_bs5_form_field, {
              id: "editUserRole",
              name: "role",
              label: _ctx.$t('users.role'),
              options: _ctx.roleChoices,
              modelValue: _ctx.user.role,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.role) = $event))
            }, null, 8, ["label", "options", "modelValue"]),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "submit",
              class: "d-none",
              tabindex: "-1",
              "aria-hidden": "true"
            }, null, -1))
          ], 40, _hoisted_1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
          _createVNode(_component_bs5_save_button, {
            loading: _ctx.saving,
            disabled: !meta.valid,
            onClick: ($event: any) => (handleSubmit($event, _ctx.updateUser))
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-check2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t("common.save")), 1)
            ]),
            _: 2
          }, 1032, ["loading", "disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["title", "visible", "onClose"])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}